import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  private api = inject(ApiService);

  remove(id: number | string): Promise<any> {
    return this.api.get(`/transaction/remove/${id}`);
  }

  refund(id: number | string): Promise<any> {
    return this.api.get(`/transaction/refund/${id}`);
  }

  getPaymentErrorData(select: { studio: { id: any }; year: { id: any }; month: { id: any } }): Promise<any> {
    const studio = select.studio.id;
    const month = `${select.year.id}-${String(select.month.id).padStart(2, '0')}`;
    return this.api.get(`/invoice/payment_error/${studio}/${month}`);
  }

  downloadedReceipt(json: any): Promise<any> {
    return this.api.post('/transaction/receipt', json);
  }
}
